import BucketIcon from 'assets/icons/BucketIcon'
import ClipBoardIcon from 'assets/icons/ClipBoardIcon'
import SummaryIcon from 'assets/icons/SummaryIcon'

export default [
  {
    title: 'View summary of the treatment',
    subTitle: 'We have prepared a summary report for the treatment',
    icon: SummaryIcon,
  },
  {
    title: 'Create a new treatment plan',
    subTitle: 'You can add a refinement as a treatment plan or any other if you wish to',
    icon: ClipBoardIcon,
  },
  {
    title: 'Start taking our services',
    subTitle: 'We offer smile simulation and other services which you can choose from',
    icon: BucketIcon,
  },
]
